import BaseAPI from './base';

class CountriesAPI extends BaseAPI {
  search(q?: string, suggest?: boolean, includeDomestic?: boolean) {
    return this.get('/api/web/v1/countries/exchange', {
      q, suggest: suggest || undefined, include_domestic: includeDomestic || undefined,
    });
  }
}

export default new CountriesAPI();
